import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Checkbox } from 'components/forms'

export const useFilterCardLocal = (data, onChange) => {
	const [selectedItems, setSelectedItems] = useState([])
	const [itemArr, setItemArr] = useState([])
	const [showModal, setShowModal] = useState(false)
	useEffect(() => {
		if(!_.isEqual(itemArr, data)) {
			setItemArr(data)
			setSelectedItems(data.map(item => item.itemValue))
		}
	}, [data])

	useEffect(() => {
		onChange(selectedItems)
	}, [selectedItems])

	const handleAllActiveClick = () => {
		if (data.length !== selectedItems.length) {
			setSelectedItems(data.map(item => item.itemValue))
		}
	}
	const handleSave = () => {
		setShowModal(null)
	}
	const handleClick = (original) => {
		const isOriginal = selectedItems.includes(original.itemValue)
		setSelectedItems(prevValue => {
			if (isOriginal && prevValue.length > 1) {
				return prevValue.filter(e => e !== original.itemValue)
			}
			if(isOriginal && prevValue.length === 1) {
				return data.map(e => e.itemValue)
			}
			if (!isOriginal && selectedItems.length !== data.length) {
				return [...prevValue, original.itemValue]
			}
			return prevValue
		})
	}
	const columns = (t) => ([
		{
			Header: t('common.strings.category'),
			accessor: 'name',
			Cell: ({ value: cellValue, original }) => (<Checkbox checked={selectedItems.includes(original.itemValue)} noForm readOnly label={cellValue}/>)
		}
	])
	const methods = {
		handlerItems: (allLabel) => itemArr.length !== selectedItems.length ? itemArr.filter(item => selectedItems.includes(item.itemValue)) : [{ name: allLabel }],
		handlerCheckAll: () => selectedItems.length === data.length,
		handlerRemoveItem: () => data.length ? (original) => handleClick(original) : null
	}
	return { methods, showModal, setShowModal, handleClick, handleAllActiveClick, handleSave, columns }
}
